import { useState } from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '@/components/auth/AuthLayout'
import LoginForm from '@/components/auth/LoginForm'
import AuthRedirect from '@/components/auth/AuthRedirect'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'

const Login = () => {
  const { user } = useAuth()

  // If user is already logged in, show redirect component
  if (user) {
    return <AuthRedirect />
  }

  return (
    <AuthLayout
      title="Anmelden"
      description="Melden Sie sich in Ihrem Herzensempfehlung-Konto an"
    >
      <LoginForm />
      
      <div className="mt-6 text-center">
        <p className="text-sm text-muted-foreground">
          Noch kein Konto?{' '}
          <Link to="/registrieren" className="text-primary hover:underline font-medium">
            Jetzt registrieren
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}

export default Login